/**
 *
 * @param {DOM element} domElemToClone  - Element to clone.
 * @param {DOM element} cloneAboveElem  - The element cloned will be cloned above/before this one.
 */
export const cloneAbove = (domElemToClone, cloneAboveElem) => {
  const clonedElem = domElemToClone.cloneNode(true)
  cloneAboveElem.parentElement.insertBefore(clonedElem, cloneAboveElem)
}
